import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuelidate from "vuelidate";
import Toasted from 'vue-toasted';
import VueCountryCode from "vue-country-code-select";
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import axios from 'axios';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import config from './config';
import Moment from 'moment';
import jQuery from 'jquery';
import infiniteScroll from 'vue-infinite-scroll';
import VueClipboard from 'vue-clipboard2';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import '@/assets/css/all.css';
import '@/assets/css/style.css';
import '@/assets/css/responsive.css';
import AuthPlugin from './plugins/authPlugin';
import VueSkeletonLoader from 'skeleton-loader-vue';
import i18n from './i18n';
import LottieAnimation from 'lottie-web-vue'
import {encryptData}  from "./helper/helper.js";

window.axios = axios;
require('dotenv').config()
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(Vuelidate);
Vue.use(VueCountryCode);
Vue.use(Moment);
Vue.use(infiniteScroll);
Vue.use(VueClipboard);
Vue.use(VueSweetalert2);
Vue.use('vue-skeleton-loader', VueSkeletonLoader);
Vue.use(LottieAnimation);



window.jQuery = jQuery;
Vue.use(Toasted, {
    duration: 4000,
    position: 'top-right',
    action: {
        onClick: (e, toastObject) => {
            toastObject.goAway(0);
        }
    }
});

Vue.use(AuthPlugin);
Vue.config.productionTip = false

window.axios.defaults.baseURL = config.api_url;
window.axios.defaults.headers.common['Content-Type'] = 'application/json';

window.axios.interceptors.request.use(
    (cnfig) => {

        const noEncryptionEndpoints = config.withoutEncrytption;
        if (noEncryptionEndpoints.some(endpoint => cnfig.url.includes(endpoint))) {
            // console.log('Skipping encryption for:', cnfig.url);
            return cnfig; 
        }

        if (cnfig.data) {
            let response = encryptData(cnfig.data);
            cnfig.data = { encd: response };
        }

        return cnfig;

    },
    (error) => {
      console.log(error, "API Interceptor Error");
      return Promise.reject(error);
    }
);



new Vue({
    router,
    store,
    directives: { infiniteScroll },
    i18n,
    render: h => h(App)
}).$mount('#app')